import CustomModal from "examples/Modal/ConfirmationModal";
import { useEffect, useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import {
  getRedeemPoints,
  generateGiftCard,
  getRedeemHistory,
  expireRedeemPoints,
} from "./_request";
import { verifyTokenApi } from "../authentication/_request";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import SimpleBackdrop from "components/MDLoader_Backdrop";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

// Data
import { getAuthLocal } from "../../core/AuthHelper";
import { useAuth } from "context";
import CollapsibleTable from "./components/CollapsibleTable.js";

import { AnalyticsEvents, CONVERSION_POINTS } from "../../core/constant";
import formatNumberWithCommas from "../../core/utils/formatNumberWithCommas";
import EmailCustomModal from "examples/Modal/EmailConfirmationModal";
import PaginationControlled from "core/utils/_pagination";
import { NavbarAlert } from "examples/Alert";

import config from "../../config/config";
import { StatCard } from "examples/Cards/StatisticsCards/StatCard";
import {
  StatCardWithButton,
  getRedeemDisabledReason,
} from "examples/Cards/StatisticsCards/StatCard";
import { getDashboardData, getNsuCashbackDetails } from "layouts/dashboard/_request";
import PendingWelcomeBonusBanner from "components/PendingWelcomeBonusBanner";
import { useAnalyticsEvent } from "hooks/useAnalyticsEvent";

const notificationEmail =
  config[process.env.REACT_APP_ENV?.toUpperCase() || "LOCAL"].NOTIFICATION_EMAIL;

function Mypoint() {
  const [refreshTable, setRefreshData] = useState(false);
  const [tableDataLoader, setTableDataLoader] = useState(true);
  const [pointsDataLoader, setPointsDataLoader] = useState(true);
  const { showSnackbarWithMessage, miniSidenav } = useAuth();
  const [loader, setLoader] = useState(false);
  const [minRedeemPoints, setMinRedeemPoints] = useState(0);
  const [maxRedeemPoints, setMaxRedeemPoints] = useState(0);
  const [openRedeemModal, setopenRedeemModal] = useState(false);
  const [redeemPoints, setRedeemPoints] = useState(0);
  const [redeemAmount, setRedeemAmount] = useState(0);
  const [userEmail, setUserEmail] = useState("");
  const [isPendingRedeempRequest, setIsPendingRedeemRequest] = useState();
  const [isPendingRedeemptionRequestAmount, setIsPendingRedeemRequestAmount] = useState();
  const [expirePoints, setExpirePoints] = useState({});
  const [pendingWelcomeBonuses, setPendingWelcomeBonuses] = useState();
  const [selectedValue, setSelectedValue] = useState("");
  const [status, setStatus] = useState({
    isOTPVisible: false,
  });
  const [otp, setOtp] = useState("");
  const [page, setPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const { trackCustomEvent } = useAnalyticsEvent();

  const handleClose = () => {
    setopenRedeemModal(!openRedeemModal);
    setStatus({
      isOTPVisible: false,
    });
    setOtp("");
  };
  const [redeemData, setRedeemData] = useState([]);
  const [totalPointsEarned, setTotalPointsEarned] = useState(0);
  const [totalRedeemedPoints, setTotalReedemedPonts] = useState(0);

  const getRedeemData = async () => {
    try {
      setTableDataLoader(true);
      const {
        data: { success, data, pagination },
      } = await getRedeemHistory(page);
      if (success) {
        setRedeemData(data?.records);
        setIsPendingRedeemRequest(data?.isPending);
        setIsPendingRedeemRequestAmount(data?.totalPendingPoints);
        setTableDataLoader(false);
        setTotalPage(pagination?.totalPages);
      } else {
        setTableDataLoader(false);
      }
    } catch (e) {
      console.log(e);
      setTableDataLoader(false);
    }
  };

  const getRedeemPointsData = async () => {
    try {
      setPointsDataLoader(true);
      const {
        data: { success, data },
      } = await getRedeemPoints();
      if (success) {
        if (data.customerPoints) {
          setRedeemPoints(data.customerPoints);
          setRedeemAmount(data.customerPoints / 100);
          setMinRedeemPoints(data.minimum_points);
          setMaxRedeemPoints(data.maximum_points);
          setPointsDataLoader(false);
        } else {
          setRedeemPoints(0);
          setRedeemAmount(0);
          setMinRedeemPoints(data.minimum_points);
          setMaxRedeemPoints(data.maximum_points);
          setPointsDataLoader(false);
        }
      }
    } catch (e) {
      console.log(e);
      setPointsDataLoader(false);
    } finally {
      setPointsDataLoader(false);
    }
  };

  const dashboardData = async () => {
    try {
      const {
        data: { success, data },
      } = await getDashboardData();
      if (success && data) {
        setTotalPointsEarned(data.pointEarned);
        setTotalReedemedPonts(data.pointRedeemed);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const getExpirePoints = async () => {
    try {
      const { data } = await expireRedeemPoints();
      if (data.success) {
        setExpirePoints(data);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const fetchPendingWelcomeBonuses = async () => {
    try {
      const {
        data: { success, data },
      } = await getNsuCashbackDetails();
      if (success) {
        setPendingWelcomeBonuses(data.pendingWelcomeBonuses);
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleConfirm = async () => {
    setLoader(true);
    try {
      if (redeemPoints < minRedeemPoints) {
        showSnackbarWithMessage({
          type: "error",
          message: `Minimum redemption is ${formatNumberWithCommas(
            minRedeemPoints
          )} points (~$${formatNumberWithCommas(minRedeemPoints / CONVERSION_POINTS)}).`,
        });
        return;
      }
      if (selectedValue) {
        const {
          data: { success, message },
        } = await generateGiftCard(selectedValue);
        if (success) {
          getRedeemData();
          await getRedeemPointsData();
          showSnackbarWithMessage({
            type: "success",
            message,
          });
          trackCustomEvent(AnalyticsEvents.REWARD_REDEEMED, {
            redeemed_amount: redeemAmount,
          });
          handleClose();
          setRefreshData(true);
        } else {
          showSnackbarWithMessage({
            type: "error",
            message,
          });
        }
      }
    } catch (e) {
      showSnackbarWithMessage({
        type: "error",
        message: e.message,
      });
    } finally {
      setLoader(false);
      setRefreshData(false);
    }
  };

  const verifyTokenFunc = async () => {
    try {
      const auth = await getAuthLocal();
      const {
        data: { success, data },
      } = await verifyTokenApi({ accessToken: auth.accessToken });
      if (success) {
        setUserEmail(data.verifiedData.email);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  useEffect(() => {
    getRedeemPointsData();
    verifyTokenFunc();
    getRedeemData();
    dashboardData();
    getExpirePoints();
    setRefreshData(false);
  }, [page, refreshTable]);

  useEffect(() => {
    fetchPendingWelcomeBonuses();
  }, []);

  return (
    <>
      <DashboardNavbar />
      <NavbarAlert />
      <DashboardLayout>
        <MDBox
          py={1}
          sx={{
            mt: 10,
            "@media (max-width:767px)": {
              mt: 8,
            },
          }}
        >
          {miniSidenav && (
            <MDBox
              sx={{
                "@media (max-width:992px)": {
                  mb: 2,
                },
              }}
            >
              My Points
            </MDBox>
          )}

          <PendingWelcomeBonusBanner items={pendingWelcomeBonuses} />

          <div className="flex items-stretch justify-between gap-3 md:gap-4 flex-col md:flex-row">
            <MDBox sx={{ width: "100%" }} mb={1.5}>
              <StatCardWithButton
                header="Available To Redeem"
                onClick={() => {
                  setopenRedeemModal(true);
                }}
                icon={true}
                btnText="Redeem Now"
                subText={
                  <h2 className="text-2xl font-semibold text-gray-900">
                    {redeemPoints
                      ? formatNumberWithCommas(redeemPoints) + " points"
                      : 0 + " points"}{" "}
                    <span className="text-[#475467]">
                      {redeemPoints
                        ? " ($" +
                          formatNumberWithCommas(redeemPoints / CONVERSION_POINTS, {
                            asCurrency: true,
                          }) +
                          ")"
                        : " ($0.00)"}
                    </span>
                  </h2>
                }
                disabled={
                  redeemPoints < minRedeemPoints ||
                  redeemPoints - isPendingRedeemptionRequestAmount <= 0 ||
                  !!isPendingRedeemptionRequestAmount
                }
                bottomText={
                  isPendingRedeempRequest &&
                  formatNumberWithCommas(isPendingRedeemptionRequestAmount / 100, {
                    asCurrency: true,
                  })
                }
                disabledReason={getRedeemDisabledReason({
                  points: redeemPoints,
                  minPoints: minRedeemPoints,
                  pendingAmountCents: isPendingRedeemptionRequestAmount || 0,
                  conversion: CONVERSION_POINTS,
                })}
                daysLeftToRedeem={expirePoints?.data?.nextExpiry?.days}
                hoursLeftToRedeem={expirePoints?.data?.nextExpiry?.hours}
                tooltipMessage="Claim your points before they expire — expired points can't be recovered."
              />
            </MDBox>
            {/* Total Points Card  */}
            <MDBox sx={{ width: "100%" }} mb={1.5}>
              <StatCard
                pointsEarned={
                  totalPointsEarned
                    ? formatNumberWithCommas(totalPointsEarned) + " points"
                    : 0 + " points"
                }
                dollarAmountEarned={
                  totalPointsEarned
                    ? " ($" +
                      formatNumberWithCommas(totalPointsEarned / CONVERSION_POINTS, {
                        asCurrency: true,
                      }) +
                      ")"
                    : " ($0.00)"
                }
                pointsRedeemed={
                  formatNumberWithCommas(totalRedeemedPoints ? Math.abs(totalRedeemedPoints) : 0) +
                  " points"
                }
                dollarAmountRedeemed={
                  totalRedeemedPoints
                    ? " (~$" +
                      formatNumberWithCommas(Math.abs(totalRedeemedPoints) / CONVERSION_POINTS, {
                        asCurrency: true,
                      }) +
                      ")"
                    : " (~$0.00)"
                }
                pointsExpiring={
                  expirePoints?.data?.pointsExpiringInNext30Days
                    ? formatNumberWithCommas(expirePoints.data.pointsExpiringInNext30Days) +
                      " points"
                    : "0 points"
                }
                dollarAmountExpiring={
                  expirePoints?.data?.pointsExpiringInNext30Days
                    ? " (~$" +
                      formatNumberWithCommas(
                        expirePoints.data.pointsExpiringInNext30Days / CONVERSION_POINTS,
                        { asCurrency: true }
                      ) +
                      ")"
                    : " (~$0.00)"
                }
              />
              {/* <ComplexStatisticsCard
                height="170px"
                color="success"
                title={
                  <MDBox>
                    <MDTypography sx={{ fontSize: "14px", color: "#7b809a", fontWeight: 300 }}>
                      Points expiring in
                    </MDTypography>
                    <MDTypography sx={{ fontSize: "14px", color: "#7b809a", fontWeight: 300 }}>
                      next 30 days
                    </MDTypography>
                  </MDBox>
                }
                bottomLeft={
                  <MDBox sx={{ mt: -2 }}>
                    <MDTypography sx={{ fontSize: "13px", color: "#7b809a", fontWeight: 300 }}>
                      {expirePoints?.pointsExpiredLastYear ? expirePoints.pointsExpiredLastYear : 0}
                      &nbsp; points expired in last year
                    </MDTypography>
                  </MDBox>
                }
                pointBrand={pointsIcon}
                pointsData={
                  <MDBox>
                    {(expirePoints?.pointsExpiringInNext30Days
                      ? expirePoints.pointsExpiringInNext30Days
                      : 0) + " points"}
                    <MDTypography
                      sx={{
                        fontSize: "0.8rem",
                        fontWeight: 400,
                      }}
                      as="span"
                    >
                      {expirePoints?.pointsExpiringInNext30Days
                        ? " (~$" +
                          formatNumberWithCommas(
                            Math.round(expirePoints?.pointsExpiringInNext30Days / CONVERSION_POINTS)
                          ) +
                          ")"
                        : " (~$" + 0 + ")"}
                    </MDTypography>
                  </MDBox>
                }
              /> */}
            </MDBox>
            {/* Upload Receipt */}
            <MDBox sx={{ width: "100%" }} mb={1.5}>
              <StatCardWithButton />

              {/* <ComplexStatisticsCard
                height="170px"
                color="dark"
                title="Minimum redemption "
                // pointBrand={redemptionIcon}
                bottomLeft={
                  <MDBox sx={{ mb: 1 }}>
                    <MDTypography sx={{ fontSize: "13px", color: "#7b809a", fontWeight: 300 }}>
                      100 points = $1
                    </MDTypography>
                    <MDTypography sx={{ fontSize: "13px", color: "#7b809a", fontWeight: 300 }}>
                      {`Max redemption - ${formatNumberWithCommas(maxRedeemPoints)} points = (~$${
                        formatNumberWithCommas(maxRedeemPoints / CONVERSION_POINTS, { asCurrency: true })
                      })`}
                    </MDTypography>
                  </MDBox>
                }
                pointsData={
                  <MDBox>
                    {formatNumberWithCommas(minRedeemPoints) + " points"}
                    <MDTypography
                      sx={{
                        fontSize: "0.8rem",
                        fontWeight: 400,
                      }}
                      as="span"
                    >
                      {minRedeemPoints
                        ? " (~$" + formatNumberWithCommas(Math.round(minRedeemPoints / CONVERSION_POINTS), { asCurrency: true }) + ")"
                        : " (~$0.00)"}
                    </MDTypography>
                  </MDBox>
                }
              /> */}
            </MDBox>
          </div>

          <MDBox
            sx={{
              mt: 2,
              "@media (max-width:767px)": {
                mt: 5,
              },
            }}
          >
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <Card>
                  <MDBox mx={3} mt={3}>
                    <MDTypography variant="h6">Redemption history</MDTypography>
                  </MDBox>
                  <MDBox pt={1}>
                    {!(tableDataLoader || pointsDataLoader) ? (
                      <>
                        <CollapsibleTable redeemData={redeemData} setRefreshData={setRefreshData} />
                        {
                          <MDBox p={2} mt={1} sx={{ display: "flex", justifyContent: "center" }}>
                            <PaginationControlled
                              page={page}
                              setPage={setPage}
                              totalPage={totalPage}
                            />
                          </MDBox>
                        }
                      </>
                    ) : (
                      <SimpleBackdrop />
                    )}
                  </MDBox>
                </Card>
              </Grid>
              {/* <Grid item xs={12} md={6} lg={4}>
                <NonRenewedPoints recentOrderData={[{}, {}]} />
              </Grid> */}
            </Grid>
          </MDBox>
        </MDBox>

        <EmailCustomModal
          open={openRedeemModal}
          handleClose={handleClose}
          color={"success"}
          title={`You are about to redeem ${formatNumberWithCommas(
            redeemPoints - (isPendingRedeemptionRequestAmount || 0)
          )} points equivalent to $${formatNumberWithCommas(
            redeemAmount -
              (isPendingRedeemptionRequestAmount ? isPendingRedeemptionRequestAmount / 100 : 0),
            { asCurrency: true }
          )} `}
          subtitle={
            "We will send you an Amazon.com gift card of the same value within the next 24-48 hours to the selected email address."
          }
          subtitle2={
            <>
              We recommend to use your <strong>personal email</strong>. If you use a work email,
              your organization&apos;s policies may block it for spam or it may be quarantined.
            </>
          }
          userEmail={userEmail}
          description={
            status.isOTPVisible ? (
              <p>
                Please check your inbox and spam for emails from:
                <p>{notificationEmail}</p>
              </p>
            ) : (
              ""
            )
          }
          onConfirm={handleConfirm}
          loader={loader}
          isIcon={true}
          setSelectedValue={setSelectedValue}
          selectedValue={selectedValue}
          setStatus={setStatus}
          status={status}
          setOtp={setOtp}
          otp={otp}
        />
      </DashboardLayout>
    </>
  );
}

export default Mypoint;
